export default __webpack_public_path__ + "static/media/home-travel-agency-destination-img03.7bbf99a4.jpg";